import { render, staticRenderFns } from "./SupplierCompanyIndex.vue?vue&type=template&id=4548e698&scoped=true&"
import script from "./SupplierCompanyIndex.vue?vue&type=script&lang=js&"
export * from "./SupplierCompanyIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4548e698",
  null
  
)

export default component.exports